'use strict';

var slicedToArray = require('../../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var React = require('react');
var Grid = require('../../Layout/Grid/Grid.js');
var withStyles = require('../../Styles/withStyles.js');
var classNames = require('classnames');
var CenteredSpinner = require('../../../core/Progress/CenteredSpinner.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = {
  responsiveIframe: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%'
  },
  responsiveContainer16By9: {
    position: 'relative',
    overflow: 'hidden',
    paddingTop: '56.25%'
  },
  block: {
    display: 'block'
  },
  none: {
    display: 'none'
  }
};

var Video = function Video(_ref) {
  var classes = _ref.classes,
      src = _ref.src;

  var _useState = React.useState(true),
      _useState2 = slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  return React__default["default"].createElement(Grid, {
    container: true,
    justify: "center",
    alignItems: "center",
    spacing: 0,
    className: classes.responsiveContainer16By9
  }, loading && React__default["default"].createElement(Grid, {
    item: true,
    className: classes.responsiveIframe
  }, React__default["default"].createElement(CenteredSpinner, null)), React__default["default"].createElement(Grid, {
    item: true,
    className: classNames__default["default"](classes.responsiveIframe, loading ? classes.none : classes.block)
  }, React__default["default"].createElement("iframe", {
    src: src,
    title: "Wistia video player",
    allowtransparency: "true",
    frameBorder: "0",
    scrolling: "no",
    className: "wistia_embed",
    name: "wistia_embed",
    allowFullScreen: true,
    height: "100%",
    width: "100%",
    onLoad: function onLoad() {
      return setLoading(false);
    }
  }), React__default["default"].createElement("script", {
    src: "https://fast.wistia.net/assets/external/E-v1.js",
    async: true
  })));
};

var Video$1 = withStyles["default"](styles)(Video);

module.exports = Video$1;
